import { useFetch } from "lib/useFetch";
import { mutateHighlightFields, parseAggregations, parsePublications } from "./parsePublicationResponse";
import { createRequestBody } from "./createRequestBody";
import { useProdCopyUrl } from "components/PreferencesDialog/redesignUtils";
import { useEffect } from "react";
import { miscSlice } from "redux/slices/miscSlice";
import { useDispatch } from "react-redux";

const jsApiUrl = (prodCopyUrl) => `/research/${prodCopyUrl}/pub/search/query`;

export const useJSFetchPublications = (searchRequest, enabled, aggs = true) => {
  const body = createRequestBody(searchRequest, aggs);

  const prodCopyUrl = useProdCopyUrl();
  const response = useFetch(jsApiUrl(prodCopyUrl), JSON.stringify(body), "POST", enabled);
  const searchResults = tryParse(response);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(miscSlice.actions.set({ key: "searchResults", value: searchResults }));
  });
  return searchResults;
};

function tryParse([data, isLoading, isError]) {
  try {
    mutateHighlightFields(data);
    const hits = parsePublications(data);
    const aggregations = parseAggregations(data.aggregations);
    const totalHits = data?.hits?.total?.value;

    return [hits, isLoading, isError, aggregations, totalHits];
  } catch (err) {
    console.error("Error parsing publication data: ", err, data);
    return [null, null, true, null, null];
  }
}
